import { createContext, useContext } from 'react';

/** O palco em que o `TravelerPickerField` abriu: o pé muda de forma com ele
 *  (botão pequeno no canto do popover, botão grande de largura total na folha,
 *  como as outras folhas do kit — datas, filtros). */
export type TravelerPickerStage = 'popover' | 'sheet';

export const TravelerPickerStageContext = createContext<TravelerPickerStage>('popover');

export function useTravelerPickerStage(): TravelerPickerStage {
  return useContext(TravelerPickerStageContext);
}
